export default {
  title: 'Agency',
  createAgency: 'Create a new Agency',
  joinAgency: 'Join a Agency',
  searchAgencyID: 'Search Agency ID',
  searchUserID: 'Search User ID',
  star: 'Agency Star',
  viewMember: 'View {{count}} Members',
  reviewMessage: 'During the agency assessment, check the progress.',
  assessmentDate: 'Assessment end time:',
  viewPersonal: 'View Personal',
  viewIncome: 'View Income',
  dissolution: 'Notice of agency dissolution',
  agencyName: 'Agency Name',
  agencySlogan: 'Agency Slogan',
  agencyCover: 'Agency Background',
  wonderfulMoment: 'Wonderful Moment',
  dissolve: 'Dissolve Agency',
  dissolveTips: 'You will not receive your salary from the agency.',
  leaveAgency: 'Leave Agency',
  leaveAgencyContent: 'You will leave this agency.',
  owner: 'Owner',
  manager: 'Manager',
  host: 'Host',
  setManager: 'Set as manager',
  unsetManager: 'Remove this manager',
  kickOut: 'Kick out',
  rewardGem: 'Agency master Salary',
  salary: {
    IncomeTips: 'My Agency Gem income',
    hostTips: 'Host with Gem income',
    rateTips: 'My Agency Reward Rate',
  },
  supporters: 'Supporters: {{num}}',
  keepLevelSuccessfully: 'Keep Level Successfully',
  keepLevel: 'Keep level',
  keepLevelRequire: 'Keeping level requires: <span>{{num}}</span>',
  upgradeLevelRequires: 'Upgrading Level requires: <span>{{num}}</span>',
  kickOutTips: 'Are you sure about kicking out the host',
  viewAgencySalary: 'View agent salary',
  join: 'Join',
  newMembersJoin: 'New members join',
  assessing: 'Assessing',
  shippingAgent: 'Shipping Agent',
  create: {
    title: 'Create Agency',
    newDescription: 'New agency assessment period description',
    toAgencies:
      'To prevent agents with insufficient experience and poor quality , we have set assessment requirements for newly joined agencies.',
    assessmentRequirements: '',
    assessmentRequirements2: 'Opening Ceremony Requirements',
    diamondsRequired: 'Diamonds Required',
    numberOfHosts: 'Number of Hosts',
    coinRewards: 'Coin Rewards',
    value: 'Value ($)',
    withInDays: 'within {{num}} days',
    assessmentTime: 'Assessment time:',
    assessTips: 'Complete the following tasks to pass',
    numHosts: '{{num}} Hosts:',
    recruitAgency: 'Recruit Hosts to join the agency (including agents)',
    receivedGems: 'Gems received by the entire agency',
    agentRewards: 'Agent Rewards',
    additionalNotes: 'Notes',
    ifFail:
      "If you do not hold an opening ceremony and fulfill the opening ceremony requirements within <span>{{num}} days</span>, your agency will be automatically closed. <br /> <br /> Gold coin rewards will be sent to the agent's account.",
    agentProfit: 'Agent Profit',
    basicProfit: 'Basic Profit',
    agentCommission: 'Agent commission up to 20%',
    activityProfit: 'Activity Profit (Agents only)',
    activityProfit0: 'New agency opening party bonus up to $125',
    activityProfit1: 'Weekly room competitions with prizes up to $150',
    activityProfit2: 'Weekly room reward event with bonuses up to 18%',
    activityProfit3: 'Monthly agent ranking bonus up to 20%',
    activityProfit4: 'Official irregular gift support and official event rewards',
    ifNeed: 'If you need details of the policy, please contact the official staff',
    customerServiceRoom: 'Customer Service Room: 1001',
  },
  submit: {
    agencyName: 'Agency Name',
    agencySlogan: 'Agency Slogan',
    introducer: 'Introducer',
    createAgency: 'Create Agency',
  },
  review: {
    recruitHosts: '<strong>{{count}} Hosts:</strong> Recruit Hosts to join the agency',
    receivedGems: '<strong>{{count}} Gem:</strong> Gems received by the entire agency',
  },
  quit: {
    title: 'Quit agency?',
    joinTime: 'Join time: ',
    quitFee: 'Quit Fee:',
    quitDescription1: 'Are you sure quit this agency?',
    quitDescription2: 'Quit for free within 7 days;',
    quitDescription3: 'after 7 days, you must to pay.',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
};
